export const passwordPattern =
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()\-_+=.<>/?[\]{}"'])[A-Za-z\d!@#$%^&*()\-_+=.<>/?[\]{}"']{8,128}$/;
